module.exports = __webpack_public_path__ + "static/vslide_2@2x-d02b9d394b8673a8a0f089410f9e0b4a.png";